import type { ApiClient, JsonValue } from "../../api";
import {
  getApiV1Modules,
  getApiV1ModulesByModule,
  getApiV1ModulesByModuleSettings,
  getApiV1ModulesNavigation,
  postApiV1ModulesByModuleDisable,
  postApiV1ModulesByModuleEnable,
  postApiV1ModulesRegister,
  putApiV1ModulesByModuleSettings,
} from "../../api/generated";
import type { RegisterModule } from "./types";

export class ModulesApi {
  constructor(private readonly client: ApiClient) {}

  list() {
    return getApiV1Modules(this.client);
  }

  navigation() {
    return getApiV1ModulesNavigation(this.client);
  }

  get(key: string) {
    return getApiV1ModulesByModule(this.client, { path: { module: key } });
  }

  enable(key: string) {
    return postApiV1ModulesByModuleEnable(this.client, {
      path: { module: key },
    });
  }

  disable(key: string) {
    return postApiV1ModulesByModuleDisable(this.client, {
      path: { module: key },
    });
  }

  settings(key: string) {
    return getApiV1ModulesByModuleSettings(this.client, {
      path: { module: key },
    });
  }

  updateSettings(key: string, settings: Record<string, JsonValue>) {
    return putApiV1ModulesByModuleSettings(this.client, {
      path: { module: key },
      body: { settings },
    });
  }

  register(manifest: RegisterModule) {
    return postApiV1ModulesRegister(this.client, { body: manifest });
  }
}
